import React, { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom';
import Header from '../layout/header/Header';
import Footer from '../layout/footer/Footer';
import styles from '../layout/Layout.module.css';

const VendorLayout = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    localStorage.removeItem('visitor');
    // localStorage.removeItem('visitorAccessToken');
  }, []);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }, [pathname]);

  return (
    <div className={styles.screenContainer}>
      <Header isVendor />
      <Outlet />
      <Footer />
    </div>
  )
}

export default VendorLayout